import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { listBatches } from "../../api/threads/batchesApi";
import { appPaths } from "../../shared/routing/appPaths";
import ErrorNotice from "../../errors/ErrorNotice";
import { useLoad } from "../../shared/loading/useLoad";

/** The project's batch runs, newest first, each with how far it has come. Nothing while there are none. */
export default function ProjectBatches({ projectId }: { projectId: string }) {
  const { t } = useTranslation();
  const load = useCallback((signal: AbortSignal) => listBatches(projectId, signal), [projectId]);
  const { state, reload } = useLoad(load);
  if (state.status === "failed") {
    return <ErrorNotice error={state.error} onRetry={reload} compact={true} />;
  }
  if (state.status === "loading" || state.value.length === 0) {
    return null;
  }
  return (
    <section className="space-y-1">
      <h3 className="app-title text-sm font-semibold">{t("batches.list.title")}</h3>
      <ul className="space-y-1 text-sm">
        {state.value.map((batch) => (
          <li key={batch.batchId}>
            <Link to={appPaths.batch(batch.batchId)} className="app-link underline">{batch.title}</Link>
            <span className="app-text-muted">
              {", "}
              {t(`batches.state.${batch.state}`)}
              {", "}
              {t("batches.list.progress", { done: batch.counts.done, failed: batch.counts.failed, count: batch.unitCount })}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
